<template>
    <main class="register-login">
        <div class="container">
          <Header :text="headerText" />
          <FormRegisterFast :type="type" />
        </div>
    </main>
</template>

<script>
import FormRegisterFast from "@/components/signupAndLogin/FormRegisterFast.vue";
import Header from "@/components/signupAndLogin/Header";
import { BASIC, STARTER, ENTERPRISE } from "@/utils/clientTypes"

export default {
    name: "RegisterFast",
    components: {
        Header,
        FormRegisterFast,
    },
    props: {
        type: {
            type: String,
            default: BASIC
        }
    },
    computed: {
      headerText() {
        switch (this.type.toLowerCase()) {
          case BASIC.toLowerCase():
            return 'Crea tu cuenta Basic y comienza a obtener inteligencia financiera automática y en línea';
          case STARTER.toLowerCase():
            return 'Crea tu cuenta Starter y comienza a recibir reportes financieros hechos por expertos en finanzas y a la medida de tu negocio';
          case ENTERPRISE.toLowerCase():
            return 'Crea tu cuenta Enterprise y comienza a recibir reportes financieros hechos por expertos en finanzas y a la medida de tu negocio'
          default:
            return `Crea tu cuenta ${this.type.toLowerCase()} y comienza a recibir reportes financieros hechos por expertos en finanzas y a la medida de tu negocio`;
        }
      }
    }

};
</script>
